import { CSSProperties } from 'react';

export const paperStyle: CSSProperties = {
  height: '100%',
  boxShadow: `0px 4px 20px rgba(0, 0, 0, 0.25)`,
};
